import { CEAttachmentAttributesBase } from './ce-attachment-attributes-base'


export class CEAttachmentAttributes extends CEAttachmentAttributesBase {

}